export function mobileMenu(state) {
  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  const menu = document.getElementById('mobile-menu');
  const header = document.querySelector('header');
  const backdrop = document.getElementById('mobile-menu-backdrop');

  if (!toggle || !menu || !header) return;

  const updateHeaderRadius = (isOpen) => {
    const headerInner = header.querySelector('[data-header-pill]');
    if (headerInner) {
      if (isOpen) {
        headerInner.classList.remove('rounded-2xl');
        headerInner.classList.add('rounded-t-2xl');
      } else {
        headerInner.classList.remove('rounded-t-2xl');
        headerInner.classList.add('rounded-2xl');
      }
    }
  };

  const updateBackdrop = (isOpen) => {
    if (backdrop) {
      if (isOpen) {
        backdrop.classList.remove('hidden');
        void backdrop.offsetWidth;
        backdrop.classList.add('active');
      } else {
        backdrop.classList.remove('active');
        setTimeout(() => {
          backdrop.classList.add('hidden');
        }, 300);
      }
    }
  };

  // Mobile sub-menu toggles
  const submenuToggles = document.querySelectorAll('[data-mobile-submenu-toggle]');

  submenuToggles.forEach((submenuToggle) => {
    submenuToggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const parentMenuItem = submenuToggle.closest('.mobile-menu-item');
      const submenu = parentMenuItem?.querySelector('.mobile-submenu');

      if (submenu) {
        const isExpanded = submenuToggle.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          submenu.classList.remove('active');
          submenuToggle.setAttribute('aria-expanded', 'false');
          parentMenuItem.setAttribute('aria-expanded', 'false');
        } else {
          submenu.classList.add('active');
          submenuToggle.setAttribute('aria-expanded', 'true');
          parentMenuItem.setAttribute('aria-expanded', 'true');
        }
      }
    });
  });

  const closeMenu = () => {
    state.isMobileMenuOpen = false;
    menu.classList.add('hidden');
    updateHeaderRadius(false);
    updateBackdrop(false);
  };

  toggle.addEventListener('click', () => {
    state.isMobileMenuOpen = !state.isMobileMenuOpen;
    menu.classList.toggle('hidden', !state.isMobileMenuOpen);
    updateHeaderRadius(state.isMobileMenuOpen);
    updateBackdrop(state.isMobileMenuOpen);
  });

  menu.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', closeMenu);
  });

  document.addEventListener('click', (e) => {
    if (state.isMobileMenuOpen) {
      const isClickInsideMenu = menu.contains(e.target);
      const isClickOnToggle = toggle.contains(e.target);
      const isClickInsideHeader = header.contains(e.target);

      if (!isClickInsideMenu && !isClickOnToggle && !isClickInsideHeader) {
        closeMenu();
      }
    }
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 1280 && state.isMobileMenuOpen) {
      closeMenu();
    }
  });
}
